define([
    "language/resource",
    "authui/iamUtils",
    "base/js/framework/controllers/bfController",
    "base/utils/cookie",
], function (i18n, iamUtils, BFController, cookieOp) {
    var ctrl = ["$scope", "$state", function ($scope, $state) {

        $scope.i18n = i18n;
        $scope.model = {
            ipIsInternational : iamUtils.ipIsInternational(),
            homepageUrl: iamUtils.ipIsInternational()? iamUtils.CONFIG.HongKongHomepageUrl : iamUtils.CONFIG.homepageUrl,
            userCenterUrl: iamUtils.CONFIG.userCenterUrl,
            consoleHomeUrl: iamUtils.CONFIG.consoleHomeUrl,
            helpCenterUrl: iamUtils.CONFIG.helpCenterUrl,
            bssAccountInfoUrl: iamUtils.CONFIG.bssAccountInfoUrl,
            styleOfSite: iamUtils.isShowByStyleOfSite(),
            cloudCommunityUrl: window.replaceDomain("https://bbs.huaweicloud.com"),
            currentLanguage: window.language,
            // currentLanguageStyle:iamUtils.isShowByStyleOfSite() ? i18n('language') : iamUtils.ipIsInternational() ? i18n('lanuage.hk') : i18n('lanuage.ch'),
            currentLanguageStyle: "",
            loginUrl: "/authui/?locale=" + window.language + ( iamUtils.getUrlParams()["service"] ? "&service=" + encodeURIComponent(iamUtils.getUrlParams()["service"]) : ""),
            isShowLogoutInResetPwdPage: false,
            logoutUrl: "/authui/logout?locale=" + window.language + ( iamUtils.getUrlParams()["service"] ? "&service=" + encodeURIComponent(iamUtils.getUrlParams()["service"]) : ""),
            ZBJLogoSrc: require("custom/images/logo_zbj.png"),
            xAccountType: iamUtils.getUrlParams()["xAccountType"] ? iamUtils.getUrlParams()["xAccountType"].toLowerCase() : "",
            languageIcon: iamUtils.isShowByStyleOfSite() ? require("custom/images/language.png") : window.language == "zh-cn" ? require("custom/images/loginLanguage-zh.png") : require("custom/images/loginLanguage-en.png"),
            showCookie: true, // 是否显示底部cookie提示
            isMobile: window.outerWidth > 500 ? false : true,
            isLiteSDK: window.navigator.userAgent.toLowerCase().indexOf("hwidoauthsdk_ver") === -1 ? false : true,
        };

        if ($scope.model.ipIsInternational) {
            $scope.model.copyRight = iamUtils.i18nFormat(i18n('copyrightNotice1_hk'), (new Date()).getFullYear());    
        } else {
            $scope.model.copyRight = iamUtils.i18nFormat(i18n('copyrightNotice1'), (new Date()).getFullYear(), iamUtils.CONFIG.baseDomain[0].toUpperCase() + iamUtils.CONFIG.baseDomain.substr(1));    
        }
        
        
        if ($scope.model.currentLanguage == "zh-cn") {
            $scope.model.currentLanguageStyle = "简体中文";
        } else if ($scope.model.currentLanguage == "en-us") {
            $scope.model.currentLanguageStyle = "English";
        } else if ($scope.model.currentLanguage == "es-us") {
            $scope.model.currentLanguageStyle = "Español";
        } else if ($scope.model.currentLanguage == "pt-br") {
            $scope.model.currentLanguageStyle = "Português";
        }

        $scope.model.mouseOnLanguageChangeArea = function(){
            $("#languageSwitch").addClass("hoverClass");
            var imagepath = "";
            if(iamUtils.isShowByStyleOfSite() == true)
            {
                imagepath = require("custom/images/language@red.png");
            }
            else
            {
                if(window.language == "zh-cn")
                {
                    imagepath = require("custom/images/loginLanguage-zh@red.png");
                }
                else
                {
                    imagepath = require("custom/images/loginLanguage-en@red.png");
                }
            }
            $("#languageSwitch img").attr('src', imagepath);
            currentLanguageColor();
        }
        $scope.model.mouseLeaveLanguageChangeArea = function(){
            var imagepath = "";
            if(iamUtils.isShowByStyleOfSite() == true)
            {
                imagepath = require("custom/images/language.png");
            }
            else
            {
                if(window.language == "zh-cn")
                {
                    imagepath = require("custom/images/loginLanguage-zh.png");
                }
                else
                {
                    imagepath = require("custom/images/loginLanguage-en.png");
                }
            } 
            $("#languageSwitch img").attr('src', imagepath);
        }
        
        $scope.model.mouseLeaveLanguagesItems=function(){
            $("#languages").css('display','none');
            $("#languages").css('color','#888888');
        }

        $scope.model.toFacebook = function()
        {
        	window.open("https://www.facebook.com/dc3data");
        }

        $scope.model.mouseLeaveLoginPageLanguagesItems=function(){
            $("#loginPageLanguages").css('display','none');
            $("#loginPageLanguages").css('color','#888888');
            $("#languageSwitch").removeClass("hoverClass");
        }

        $scope.model.changeLanguage = function(id){
            if(id.indexOf("ch") !== -1) {
                refreshPage(id.substring(3), $scope);
            }

            send2CloudBISafe("input", "change" , "login_"  +"changeLanguage", id);
        }

        $scope.BiEvent = function(){
            try{
                var temp = $.extend([],arguments);
                send2CloudBI.apply(null, temp.slice(2));
            }catch(e){
                console.dir(e)
            }
        };

        function currentLanguageColor(){
            if(iamUtils.isShowByStyleOfSite() == false)
            {
                if ($scope.model.currentLanguage == "zh-cn") {
                    $scope.model.currentLanguageStyle = "简体中文";
                    $("#ch-zh-cn").addClass("currentLanguageActive").siblings().removeClass("currentLanguageActive");
                } else if ($scope.model.currentLanguage == "en-us") {
                    $scope.model.currentLanguageStyle = "English";
                    $("#ch-en-us").addClass("currentLanguageActive").siblings().removeClass("currentLanguageActive");
                } else if ($scope.model.currentLanguage == "es-us") {
                    $scope.model.currentLanguageStyle = "Español";
                    $("#ch-es-us").addClass("currentLanguageActive").siblings().removeClass("currentLanguageActive");
                } else if ($scope.model.currentLanguage == "pt-br") {
                    $scope.model.currentLanguageStyle = "Português";
                    $("#ch-pt-br").addClass("currentLanguageActive").siblings().removeClass("currentLanguageActive");
                }
            }
        }

        function refreshPage (language, $scope) {
            var searchStr = window.location.search.substring(1);
            if (searchStr === "")
            {
                window.location.search = "locale=" + language;
            }
            else
            {
                var newSearchStr = "";
                var params = searchStr.split("&");
                var needAddLocale = true;
                // 取出URL中的locale参数，替换为新的语言
                for (var index = 0; index < params.length; index++) {
                    var key = params[index].substring(0, params[index].indexOf("="));
                    if("locale" === key)
                    {
                        var value = params[index].substring(params[index].indexOf("=") + 1);
                        params[index] = key + "=" + language;
                        needAddLocale = false;
                    }
                    if(index === 0)
                    {
                        newSearchStr += params[index];
                    }
                    else
                    {
                        newSearchStr += ("&" + params[index]);
                    }
                }
                if(needAddLocale)
                {
                    newSearchStr += ("&locale=" + language)
                }
                window.location.search = newSearchStr;
            }
        }
        function send2CloudBISafe(){
            try{
                send2CloudBI.apply(null,arguments);

            }catch(e){
                console.dir(e)
            }
        }

        if(iamUtils.CONFIG.styleOfSite == "Russia")
        {
        	//$scope.model.logoSrc = require("custom/images/logo_en-us.png");
            $scope.model.logoSrc = require("custom/images/logo.svg");
        	
        	$scope.model.languages = {
                "1_en": {
                    key: "en-us",
                    value: "English"
                }
            };
        	
        	var helpCenterUrl = iamUtils.CONFIG.helpCenterUrl;
        	$scope.model.helpCenterUrl = (helpCenterUrl != "" && helpCenterUrl != "undefined") ? helpCenterUrl : 'http://support.huaweicloud.com/en-us/';
        }
        else
        {
	        $scope.model.languages = {
	            "1_zh": {
	                key: "zh-cn",
	                value: "简体中文"
	            },
	            "2_en": {
	                key: "en-us",
	                value: "English"
	            }
	        };

	        if(window.language === 'zh-cn') {
                /*替换最新logo*/
	            // $scope.model.logoSrc = require("custom/images/logo.svg");
	            $scope.model.helpCenterUrl = iamUtils.ipIsInternational()? "https://support-intl.huaweicloud.com/zh-cn/" : 'http://support.huaweicloud.com/';
	        } else {
	        	// $scope.model.logoSrc = require("custom/images/logo-en.svg");
	        	$scope.model.helpCenterUrl = iamUtils.ipIsInternational()? "https://support-intl.huaweicloud.com/": 'http://support.huaweicloud.com/en-us/';
            }

            $scope.model.helpCenterUrl = window.replaceDomain($scope.model.helpCenterUrl);

            $scope.model.loginPageLanguages = {
                "1_zh": {
                    key: "ch-zh-cn",
                    value: "简体中文"
                },
                "2_en": {
                    key: "ch-en-us",
                    value: "English"
                },
                "3_es": {
                    key: "ch-es-us",
                    value: "Español"
                },
                "4_pt": {
                    key: "ch-pt-br",
                    value: "Português"
                },

            };
            if (window.language === 'zh-cn' && !$scope.model.isLiteSDK) {
                $scope.model.logoSrc = require("custom/images/logo.svg");
            } else if(!$scope.model.isLiteSDK){
                $scope.model.logoSrc = require("custom/images/logo-en.svg");
            }
        }
        
        $scope.footer = {};
        $scope.model.showICP = false;
        $scope.model.showICP = $scope.model.currentLanguage == 'zh-cn' ? true : false;
        $scope.swapICP = function() {
            $scope.model.showICP = !$scope.model.showICP;
        }

        var footerModel = {
            // 法律声明 国内IP下显示
            legalNotice: {
                "zh-cn": $scope.model.ipIsInternational ? "" : 'https://www.huaweicloud.com/declaration/statement.html',
                "en-us": $scope.model.ipIsInternational ? "" : 'https://www.huaweicloud.com/en-us/declaration/statement.html',
                "es-us": $scope.model.ipIsInternational ? "" : 'https://www.huaweicloud.com/en-us/declaration/statement.html',
                "pt-br": $scope.model.ipIsInternational ? "" : 'https://www.huaweicloud.com/en-us/declaration/statement.html'
            },
            // 网站条款 海外IP下显示
            siteTerms: {
                "zh-cn": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/zh-cn/declaration/statement.html" : "",
                "en-us": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/en-us/declaration/sa_st.html" : "",
                "es-us": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/en-us/declaration/sa_st.html" : "",
                "pt-br": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/en-us/declaration/sa_st.html" : "",
            },
            // 隐私政策
            privacyProtect: {
                "zh-cn": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/zh-cn/declaration/sa_prp.html" : 'https://www.huaweicloud.com/declaration/sa_prp.html',
                "en-us": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/en-us/declaration/sa_prp.html" : 'https://www.huaweicloud.com/en-us/declaration/sa_prp.html',
                "es-us": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/en-us/declaration/sa_prp.html" : 'https://www.huaweicloud.com/en-us/declaration/sa_prp.html',
                "pt-br": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/en-us/declaration/sa_prp.html" : 'https://www.huaweicloud.com/en-us/declaration/sa_prp.html'
            },
            reportAbuse: {
                "en-us": $scope.model.ipIsInternational ? "http://portal-intl.huaweicloud.com/feedback?type=jubao" : 'https://portal.huaweicloud.com/en-us/feedback?type=jubao',
                "zh-cn": $scope.model.ipIsInternational ? "http://portal-intl.huaweicloud.com/zh-cn/feedback?type=jubao" : 'https://portal.huaweicloud.com/feedback?type=jubao',
            },
            sa_nisr: {
                "en-us": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/declaration/sa_nisr.html" : 'http://www.huaweicloud.com/en-us/declaration/sa_nisr.html',
                "zh-cn": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/zh-cn/declaration/sa_nisr.html" : 'http://www.huaweicloud.com/declaration/sa_nisr.html'
            },
            sa_cua: {
                "en-us": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/declaration/sa_cua.html" : 'http://www.huaweicloud.com/en-us/declaration/sa_cua.html',
                "zh-cn": $scope.model.ipIsInternational ? "http://intl.huaweicloud.com/zh-cn/declaration/sa_cua.html" : 'http://www.huaweicloud.com/declaration/sa_cua.html'
            },
            cookies: {
                "en-us": $scope.model.ipIsInternational ? 'https://www.huaweicloud.com/intl/en-us/declaration/sa_cookies.html' : 'https://www.huaweicloud.com/declaration/sa_cookies.html',
                "zh-cn": $scope.model.ipIsInternational ? 'https://www.huaweicloud.com/intl/zh-cn/declaration/sa_cookies.html' : 'https://www.huaweicloud.com/declaration/sa_cookies.html',
                "es-us": $scope.model.ipIsInternational ? 'https://www.huaweicloud.com/intl/es-us/declaration/sa_cookies.html' : 'https://www.huaweicloud.com/declaration/sa_cookies.html',
                "pt-br": $scope.model.ipIsInternational ? 'https://www.huaweicloud.com/intl/pt-br/declaration/sa_cookies.html' : 'https://www.huaweicloud.com/declaration/sa_cookies.html',
            }
        };
       
        var footerModelRussia = {
        		paymentMethods: {
                    "en-us": "https://www.huaweicloud.ru/payments.html",
                    "zh-cn": "https://www.huaweicloud.ru/payments.html"
                },
                userAgreement: {
                    "en-us": "https://www.huaweicloud.ru/agreement.html",
                    "zh-cn": "https://www.huaweicloud.ru/agreement.html"
                },
                contactUs: {
                    "en-us": "https://www.huaweicloud.ru/contacts.html",
                    "zh-cn": "https://www.huaweicloud.ru/contacts.html",
                },
                privacyPolicy: {
                    "en-us": "https://www.huaweicloud.ru/privacy.html",
                    "zh-cn": "https://www.huaweicloud.ru/privacy.html"
                },
                cookies: {
                    "en-us": "https://www.huaweicloud.ru/cookies.html",
                    "zh-cn": "https://www.huaweicloud.ru/cookies.html"
                }
        }
        
        if(iamUtils.CONFIG.styleOfSite == "Russia")
        {
        	
        	for (var link in footerModelRussia) {
                if (Object.prototype.hasOwnProperty.call(footerModelRussia, link)) {
                    $scope.footer[link] = window.replaceDomain(footerModelRussia[link][window.language]);
                }
            }
        }
        else
        {
        	for (var link in footerModel) {
                if (Object.prototype.hasOwnProperty.call(footerModel, link)) {
                    $scope.footer[link] = window.replaceDomain(footerModel[link][window.language]);
                }
            }
        }

        if(!$scope.model.isMobile){
            if ($state.is("login") || $state.is("hwIDLogin")) {
                addBackgroundForLogin();
            } else { 
                addBackground();
            }
        }

        function addBackgroundForLogin(){
            var imgpath = require("custom/images/background_login.jpg");
            $("#content").css("background-image","url("+imgpath+")");
            $("#content").css("background-size","cover");
        }
        function addBackground(){
            var imgpath = require("custom/images/background.jpg");
            $("#content").css("background-image","url("+imgpath+")");
            $("#content").css("background-size","cover");
        }

        
        $scope.cookieClick = function () {
            window.location.href = window.replaceDomain($scope.footer.cookies);
        }
        $scope.hideCookieMsg = function () {
            cookieOp.addCookie("hideIAMCookieMsg", "true", cookieOp.DEFAULT_EXPIRES_TIME);
            $scope.model.showCookie = false;
        }
        function initCookieMsg() {
            if (cookieOp.getCookie("hideIAMCookieMsg") && cookieOp.getCookie("hideIAMCookieMsg") === "true") {
                $scope.model.showCookie = false;
            }
        }
        initCookieMsg();
        //如果是litesdk则不显示语言栏
        function isLiteSDK(){
            var ua = window.navigator.userAgent.toLowerCase();
            var showConfig = iamUtils.getShowConfig(cookieOp);
            if (ua.indexOf("hwidoauthsdk_ver") > -1 || !showConfig.lang) {
                $("#banner").css('display', 'none');
                $('#banner').append("<style>#loginForm .loginTypeDiv{margin-top:0 !important}#content:before{padding-top: 0px}</style>");
            }
        }
        isLiteSDK();
        
        BFController.call(this, $scope);
         
    }];

    return ctrl;
});


// WEBPACK FOOTER //
// ./public/hws/js/framework/controllers/bfController.js